import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import List from '@material-ui/core/List';

import SidebarMenu from './config';
import { MenuItem } from './MenuItem';
import { useSidebarStyles } from './styles';
import { findParentRoutes } from './utils';

export const Sidebar = ({ children }) => {
  const { isSidebarOpen } = useSelector(({ app }) => app.ui);
  const classes = useSidebarStyles({ isSidebarOpen });
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState({});

  useEffect(() => {
    const parentRoutes = findParentRoutes(SidebarMenu, location.pathname);
    setExpandedItems(parentRoutes);
  }, [location.pathname]);

  const handleExpand = (route, level) => {
    setExpandedItems(prev => {
      if (prev[level] === route) {
        const { [level]: _, ...rest } = prev;
        return rest;
      }
      return {
        ...prev,
        [level]: route
      };
    });
  };

  return (
    <>
      <div className={classes.childrenWrapper}>{children}</div>
      <nav className={classes.nav}>
        <List component="ul" disablePadding className={classes.menuList}>
          {SidebarMenu.map(item => (
            <MenuItem
              key={item.route || item?.url}
              item={item}
              expandedItems={expandedItems}
              onExpand={handleExpand}
              isSidebarOpen={isSidebarOpen}
            />
          ))}
        </List>
      </nav>
    </>
  );
};
